const ACTIVE_TENANT_STORAGE_KEY = 'tark.activeTenantId';

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

export function getStoredActiveTenantId(): number | null {
  if (!canUseStorage()) {
    return null;
  }

  const rawValue = window.sessionStorage.getItem(ACTIVE_TENANT_STORAGE_KEY);
  if (!rawValue) {
    return null;
  }

  const parsed = Number(rawValue);
  return Number.isFinite(parsed) ? parsed : null;
}

export function setStoredActiveTenantId(tenantId: number | null | undefined): void {
  if (!canUseStorage()) {
    return;
  }

  if (tenantId == null) {
    window.sessionStorage.removeItem(ACTIVE_TENANT_STORAGE_KEY);
    return;
  }

  window.sessionStorage.setItem(ACTIVE_TENANT_STORAGE_KEY, String(tenantId));
}

export function clearStoredActiveTenantId(): void {
  if (!canUseStorage()) {
    return;
  }

  window.sessionStorage.removeItem(ACTIVE_TENANT_STORAGE_KEY);
}
